<template>
    <div class="card">
        <div class="card-title">领域热度排行榜</div>
        <div ref="chartRef" class="chart-container"></div>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import * as echarts from 'echarts'

const chartRef = ref(null)

const scenicData = [
    { name: '数据泄露', value: 92 },
    { name: 'APT攻击', value: 87 },
    { name: '恶意软件', value: 81 },
    { name: '病毒事件', value: 76 },
    { name: '重要漏洞', value: 71 },
    { name: '前沿技术', value: 68 },
    { name: '军事演习', value: 6 }
]

onMounted(() => {
    const chart = echarts.init(chartRef.value)
    chart.setOption({
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            },
            formatter: '{b}：{c}件'
        },
        grid: {
            left: '3%',
            right: '5%',
            bottom: '3%',
            containLabel: true
        },
        xAxis: {
            type: 'value',
            boundaryGap: [0, 0.01],
            axisLine: { lineStyle: { color: '#2c70b6' } },
            axisLabel: { color: '#fff' },
            splitLine: { show: false }
        },
        yAxis: {
            type: 'category',
            data: scenicData.map(item => item.name),
            axisLine: { lineStyle: { color: '#2c70b6' } },
            axisLabel: { color: '#fff' }
        },
        series: [
            {
                type: 'bar',
                data: scenicData.map(item => item.value),
                barWidth: 16,
                itemStyle: {
                    color: '#00f6ff',
                    borderRadius: [0, 8, 8, 0]
                },
                label: {
                    show: true,
                    position: 'right',
                    color: '#fff'
                }
            }
        ]
    })
})
</script>

<style scoped>
.card {
    background: rgba(0, 52, 101, 0.7);
    border-radius: 8px;
    padding: 16px;
    color: #ffffff;
}

.card-title {
    font-size: 16px;
    font-weight: bold;
    color: #00ffff;
    margin-bottom: 12px;
}

.chart-container {
    width: 100%;
    height: 280px;
}
</style>